import { API } from 'aws-amplify';
import { useState } from 'react';

import { TSchoolSearchCondition } from 'src/types';
import { IDISearchRecord, TDISchool } from 'src/di/types';

import { searchActive } from './searchActive';

export const searchDIs = async (searchData: TSchoolSearchCondition) => {
  // The AI Form project's match endpoint has been updated to take an additional paraameter called EntityType
  // to identify aiSearch Vs diSeaarch, so same endpoint can be reused using orgSearch for both searches
  let matchAPIInputData = {
    OrgName: searchData.OrgName,
    Country: searchData.Country,
    Zip: searchData.Zip,
    EntityType: 'di',
  };
  const data = await API.post('AiFormRequest', '/save?key=match', {
    body: matchAPIInputData,
  });
  return data;
};

const mapDI = (dischool: any): TDISchool => {
  const schoolInfo: TDISchool = {
    orgId: dischool._source.org_id,
    orgName: dischool._source.org_full_name,
    orgAddress: dischool._source.org_street_addr1,
    orgCity: dischool._source.org_city,
    orgStateCode: dischool._source?.org_state_cd,
    orgZip: dischool._source?.org_zip5,
    orgCountryCode: dischool._source.org_country_iso_cd,
    orgProvince: dischool._source?.org_province,
    orgPostalCode: dischool._source?.org_intl_postal_code,
    diCode: dischool._source.di.di_code,
    diSatPgmInd: dischool._source.di.sat_pgm_active_ind,
    diApPgmInd: dischool._source.di.ap_pgm_active_ind,
    diClepPgmInd: dischool._source.di.clep_pgm_active_ind,
  };
  if (!(dischool._source.org_country_iso_cd === 'US' || dischool._source.org_country_iso_cd === '')) {
    schoolInfo.orgZip = dischool._source.org_zip4;
  }

  return schoolInfo;
};

const mapDISearch = (dischools: any) => {
  const mapped: TDISchool[] = dischools.map((dischool: any): TDISchool => {
    return mapDI(dischool);
  });
  return mapped.flat();
};

export const useSearchDI = () => {
  const [isLoading, setLoading] = useState(false);
  const [failure, setError] = useState('');
  const [data, setData] = useState<IDISearchRecord[]>([]);
  const [total, setTotal] = useState<number>(0);

  const search = async (params: TSchoolSearchCondition) => {
    setLoading(true);
    try {
      const searchResult = await searchDIs(params);
      console.log('searchResult: ', searchResult);
      const dischools = searchResult?.hits?.hits || [];
      const dis = mapDISearch(dischools);
      const orgIds: string[] = dis.map((school: TDISchool) => {
        return school.orgId;
      });
      const records = await searchActive({ ids: orgIds, recordCategoryType: 'di' });
      const active = records.active;
      const owned = records.owned;

      const results: IDISearchRecord[] = [];
      for (const di of dis) {
        const activeRequest = active.find(summary => summary.orgId === di.orgId);
        const ownedRequest = owned.find(summary => summary.processStatus === 'submitted' && summary.orgId === di.orgId);

        results.push({
          di: di,
          active: activeRequest,
          owned: ownedRequest,
        });
      }
      setTotal(searchResult?.hits?.total || 0);
      setData(results);
    } catch (error: any) {
      setError(error.message);
    }
    setLoading(false);
  };

  return { isLoading, failure, total, data, search };
};
